import React, { useState, useCallback } from 'react';
import DisplayList, { DisplayNoData } from '../blog/result-list';
import { useEffectAsync, useParameters } from '../../utils';
import { getCategories, getPostsHeaders, getTags, getTravel_infosHeaders, getAmbassadorsHeaders, getPdfsHeaders, getDestinationsHeaders, getPagesHeaders, getAll, getPress_releasesHeaders } from '../../services/api';
import { PostCollections } from '../blog/utils';
import { DisplayArticle } from '../blog/blog-article';

const postCollectionFunctions: Record<PostCollections, (p : {
    page?: number;
    per_page?: number;
    search?: string;
    order?: "asc" | "desc";
    orderby?: "modified" | "relevance";
    categories?: string;
    tags?: string 
    lang?: string;
}) => Promise<DisplayArticle[]>> = {
    "travel-info": getTravel_infosHeaders,
    ambassadors: getAmbassadorsHeaders,
    "press-releases": getPress_releasesHeaders,
    ebook: getPdfsHeaders,
    post: getPostsHeaders,
    destination: getDestinationsHeaders,
    page: getPagesHeaders,
    all: getAll
}
export default BlogResultsPage;
export function BlogResultsPage() {
    const lang = "en";// hardocded language for now, move this to the desturecture below when content is ready.
    const { searchText, searchType, collection = "post"} = useParameters<{
        searchType?: "category" | "tag" | "text",
        collection?: PostCollections,
        searchText?: string,
        lang?: string,
    }>();

    const [displayComponent, setDisplayComponent] = useState(true);
    const [title, setTitle] = useState("");
    useEffectAsync(async () => {
        setDisplayComponent(true)
        setTitle("") // Set it to "" so we don't see old data while we wait for the API to return data
        if (searchType === "category") {
            const result = await getCategories({
                slug: searchText,
                lang: lang,
            });
            setTitle(result[0]?.name ?? searchText)
        }
        if (searchType == "text") {
            setTitle(searchText!);
        }
        if (searchType == "tag") {
            const result = await getTags({
                slug: searchText
            });
            setTitle(result[0]?.name ?? searchText)
        }

    }, [searchType, searchText, lang, collection])

    const pageLoader = useCallback(async (p: {
        skip: number;
        limit: number;
    }) => (await postCollectionFunctions[collection ?? "post"]({
        page: p.skip / 10 + 1,
        per_page: p.limit,
        categories: searchType === "category" ? searchText : undefined,
        tags: searchType === "tag" ? searchText : undefined,
        search: searchType === "text" ? searchText : undefined,
        lang: lang,
        orderby: searchType === "text" ? "relevance": "modified"
    })), [searchType, searchText, lang, collection])
    
    if (displayComponent) {
        return <div>
            <div className='topic-wrapper'>
                <DisplayList key={searchText} title={title} collection={collection} loader={pageLoader}></DisplayList>
            </div>
        </div>
    } else {
        return <div className='topic-wrapper'>
            <DisplayNoData />
        </div>
    }
}